export default __webpack_public_path__ + "static/assets/ff69eb6d9e2044232f0187954982fb3c.png";